import { useContext } from 'react';
import { CustomerInteractionContext } from '../context';

export const useCustomerInteraction = () => useContext(CustomerInteractionContext);
